import { __exports as merge } from "./index147.js";
var hasRequiredMerge;
function requireMerge() {
  if (hasRequiredMerge) return merge;
  hasRequiredMerge = 1;
  Object.defineProperty(merge, "__esModule", {
    value: true
  });
  var _extends = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  merge.default = function(old, replaceObj) {
    return _extends({}, old, replaceObj);
  };
  return merge;
}
export {
  requireMerge as __require
};
//# sourceMappingURL=index127.js.map
